import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { ZoomIn } from "lucide-react";

/**
 * <AttractionsMarquee /> — infinite right-to-left, pause-on-hover.
 * Click a tile → lightbox opens with a cinematic zoom.
 */
export default function AttractionsMarquee({ items = [], onOpen }) {
  if (!items.length) return null;

  // Duplicate once if we have fewer than 6 tiles so the marquee always feels full.
  const strip = items.length < 6 ? [...items, ...items] : items;

  return (
    <div className="marquee-fade" data-testid="attractions-marquee">
      <Marquee gradient={false} speed={40} pauseOnHover pauseOnClick>
        {strip.map((a, i) => (
          <motion.button
            key={`${a.id}-${i}`}
            type="button"
            onClick={() =>
              onOpen &&
              onOpen({
                src: a.img,
                title: a.name,
                subtitle: "Nearby attraction",
                alt: a.name,
              })
            }
            whileHover={{ y: -4 }}
            transition={{ type: "spring", stiffness: 220, damping: 18 }}
            aria-label={`Open ${a.name} in fullscreen`}
            className="group relative m-3 sm:m-4 w-[280px] sm:w-[380px] h-[220px] sm:h-[280px] shrink-0 rounded-3xl overflow-hidden ring-1 ring-black/10 bg-[var(--pam-forest)] focus:outline-none focus-visible:ring-[var(--pam-gold)]"
            data-testid={`marquee-tile-${a.id}`}
          >
            <img
              src={a.img}
              alt={a.name}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 via-black/25 to-transparent p-5 flex items-end justify-between text-white">
              <span className="font-serif text-lg sm:text-xl">{a.name}</span>
              <span className="opacity-0 group-hover:opacity-100 transition-opacity w-9 h-9 rounded-full bg-white/15 backdrop-blur grid place-items-center">
                <ZoomIn className="w-4 h-4" />
              </span>
            </div>
          </motion.button>
        ))}
      </Marquee>
    </div>
  );
}
